import React from 'react';

import { cn } from '@/utils/lib/cn'; // adjust path as needed

interface SeparatorProps {
  className?: string;
  type?: 'horizontal' | 'vertical'; // optional prop
}

const Separator: React.FC<SeparatorProps> = ({
  className,
  type = 'horizontal',
}) => {
  const isVertical = type === 'vertical';

  return (
    <div
      className={cn(
        isVertical ? 'h-full w-[2px]' : 'h-[2px] w-full',
        'mx-auto border-2 border-transparent',
        className,
      )}
      style={{
        borderImageSource: isVertical
          ? 'linear-gradient(180deg, rgba(0, 0, 0, 0.24), rgba(255, 255, 255, 0.24), rgba(0, 0, 0, 0.24))'
          : 'linear-gradient(90deg, rgba(0, 0, 0, 0.24), rgba(255, 255, 255, 0.24), rgba(0, 0, 0, 0.24))',
        borderImageSlice: 1,
        borderRight: isVertical ? undefined : 'none',
        borderTop: isVertical ? 'none' : undefined,
      }}
    />
  );
};

export default Separator;
